import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { dataset as fOverallData } from "../data/fOverall";
import { dataset as mOverallData } from "../data/mOverall";

export const useQueryOverallRankTrends = ({
	listOption,
	overallRankFilter,
}) => {
	const queryFn = async ({ signal }) => {
		const records = listOption === "f" ? fOverallData : mOverallData;

		return {
			records:
				overallRankFilter === "top-30"
					? records.filter(({ data }) => data[2].y !== null)
					: overallRankFilter === "top-21"
					? records.filter(({ data }) => data[3].y !== null)
					: overallRankFilter === "top-18"
					? records.filter(({ data }) => data[4].y !== null)
					: overallRankFilter === "top-16"
					? records.filter(({ data }) => data[5].y !== null)
					: overallRankFilter === "top-14"
					? records.filter(({ data }) => data[6].y !== null)
					: overallRankFilter === "top-12"
					? records.filter(({ data }) => data[7].y !== null)
					: overallRankFilter === "top-10"
					? records.filter(({ data }) => data[7].y !== null && data[7].y < 6)
					: records,
			lastRefreshTime: moment("2022-09-25T23:00:00"),
		};
	};

	return useQuery(
		["overallRankTrends", { listOption, overallRankFilter }],
		queryFn,
		{
			retry: false,
		}
	);
};
